/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */

import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import {
  Card,
  CardContent,
  // CardActions,
  CardHeader,
  // InputAdornment,
  // IconButton,
  // MenuItem,
  Button,
  CircularProgress,
  Grid,
  TextField
} from '@mui/material';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import SettingAction from '../../../store/actions/SettingAction';
import ContentLoader from '../../../utils/errorPages/ContentLoader';
import { ValidateStripe } from '../../../assets/validation';
import useHasPermission from '../../../utils/useHasPermission';
import { paymentSettings, index, store } from '../../../utils/constants';
import IOSSwitchStyle from '../../../components/SwitchField';

export default function PaymentStipe() {
  const [data, setData] = useState([]);
  const [modeValue, setModeValue] = useState('');

  const dispatch = useDispatch();
  const { stripeData, isLoading } = useSelector((state) => state.setting); // Replace 'data' with your reducer name

  useEffect(() => {
    dispatch(SettingAction.getStripe());
  }, [dispatch]);

  useEffect(() => {
    if (stripeData && stripeData?.data) {
      setData(stripeData.data);
      if (stripeData.data?.STRIPE_MODE) {
        setModeValue(stripeData.data.STRIPE_MODE);
      }
    }
  }, [stripeData]);

  const getDirtyValues = (values, initialObject) => {
    const newdata = { ...values };
    const keyValues = Object.keys(newdata);

    const dirtyValues = keyValues.filter(
      (keyValue) => newdata[keyValue] !== initialObject[keyValue]
    );

    keyValues.forEach((key) => {
      if (!dirtyValues.includes(key)) delete newdata[key];
    });
    return newdata;
  };

  const initialValues = {
    STRIPE_MODE: data?.STRIPE_MODE ?? '',
    STRIPE_SANDBOX_KEY: data?.STRIPE_SANDBOX_KEY ?? '',
    STRIPE_SANDBOX_SECRET: data?.STRIPE_SANDBOX_SECRET ?? '',
    STRIPE_LIVE_KEY: data?.STRIPE_LIVE_KEY ?? '',
    STRIPE_LIVE_SECRET: data?.STRIPE_LIVE_SECRET ?? '',
    STRIPE_IS_ENABLED: data?.STRIPE_IS_ENABLED
  };

  const permissionAccess = !(
    useHasPermission(paymentSettings, index) && useHasPermission(paymentSettings, store)
  );

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      {isLoading ? <ContentLoader /> : ''}
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={ValidateStripe}
        onSubmit={(values, { setErrors, setSubmitting }) => {
          console.log(values, 'values');
          const updateValues = getDirtyValues(values, initialValues);
          dispatch(SettingAction.updateStripe(updateValues, setErrors, setSubmitting));
        }}
      >
        {({
          errors,
          touched,
          values,
          handleBlur,
          handleChange,
          handleSubmit,
          handleReset,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit}>
            <Card>
              <CardContent>
                <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                  <Grid item lg={3} xl={2}>
                    <FormControl sx={{ mt: 2, width: '100%', textAlign: 'left' }}>
                      <FormLabel id="statusId" required={!permissionAccess}>
                        Stripe Mode
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="statusId-label"
                        name="STRIPE_MODE"
                        value={values.STRIPE_MODE}
                        onChange={(e) => {
                          setFieldValue('STRIPE_MODE', e.target.value);
                          setModeValue(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          // disabled={permissionAccess}
                          value="sandbox"
                          control={<Radio />}
                          label="Sandbox"
                        />
                        <FormControlLabel
                          // disabled={permissionAccess}
                          value="live"
                          control={<Radio />}
                          label="Live"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item lg={3} xl={3}>
                    <FormControl sx={{ mt: 2, width: '100%', textAlign: 'left' }}>
                      <FormLabel id="statusId" required={!permissionAccess} sx={{ mb: 1 }}>
                        Status
                      </FormLabel>
                      <IOSSwitchStyle
                        size="small"
                        disabled={permissionAccess}
                        checked={values.STRIPE_IS_ENABLED === 1}
                        value={values.STRIPE_IS_ENABLED}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setFieldValue('STRIPE_IS_ENABLED', 1);
                          } else {
                            setFieldValue('STRIPE_IS_ENABLED', 2);
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                {modeValue === 'sandbox' ? (
                  <Card sx={{ mt: 2, maxWidth: '65%' }}>
                    <CardHeader
                      sx={{ textAlign: 'left !important' }}
                      title="Sandbox Configuration"
                    />
                    <CardContent>
                      <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                        <Grid item lg={6} xl={6}>
                          <TextField
                            error={errors.STRIPE_SANDBOX_KEY && touched.STRIPE_SANDBOX_KEY}
                            label="Stripe Sandbox Key"
                            className=""
                            fullWidth
                            type="text"
                            name="STRIPE_SANDBOX_KEY"
                            value={values.STRIPE_SANDBOX_KEY}
                            disabled={permissionAccess}
                            // maxRows={4}
                            placeholder="Enter Kye"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.STRIPE_SANDBOX_KEY &&
                              touched.STRIPE_SANDBOX_KEY &&
                              errors.STRIPE_SANDBOX_KEY
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                        <Grid item lg={6} xl={6}>
                          <TextField
                            error={errors.STRIPE_SANDBOX_SECRET && touched.STRIPE_SANDBOX_SECRET}
                            label="Stripe Sandbox Secret"
                            className=""
                            fullWidth
                            type="text"
                            name="STRIPE_SANDBOX_SECRET"
                            value={values.STRIPE_SANDBOX_SECRET}
                            disabled={permissionAccess}
                            // maxRows={4}
                            placeholder="Enter Secret"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.STRIPE_SANDBOX_SECRET &&
                              touched.STRIPE_SANDBOX_SECRET &&
                              errors.STRIPE_SANDBOX_SECRET
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                ) : (
                  <Card sx={{ mt: 2, maxWidth: '65%' }}>
                    <CardHeader sx={{ textAlign: 'left !important' }} title="Live Configuration" />
                    <CardContent>
                      <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                        <Grid item lg={6} xl={6}>
                          <TextField
                            id="STRIPE_LIVE_KEY"
                            fullWidth
                            label="Stripe Live Login ID"
                            name="STRIPE_LIVE_KEY"
                            type="text"
                            margin="normal"
                            placeholder="Enter Login ID"
                            disabled={permissionAccess}
                            value={values.STRIPE_LIVE_KEY}
                            onChange={handleChange}
                            onBlur={(e) => {
                              const val = (e.target.value || '').replace(/\s+/gi, '');
                              setFieldValue(e.target.name, val.trim());
                              handleBlur(e);
                            }}
                            error={errors.STRIPE_LIVE_KEY && touched.STRIPE_LIVE_KEY}
                            helperText={
                              errors.STRIPE_LIVE_KEY &&
                              touched.STRIPE_LIVE_KEY &&
                              errors.STRIPE_LIVE_KEY
                            }
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                        <Grid item lg={6} xl={6}>
                          <TextField
                            error={errors.STRIPE_LIVE_SECRET && touched.STRIPE_LIVE_SECRET}
                            label="Stripe Live Secret Key"
                            className=""
                            fullWidth
                            type="text"
                            name="STRIPE_LIVE_SECRET"
                            value={values.STRIPE_LIVE_SECRET}
                            disabled={permissionAccess}
                            // maxRows={4}
                            placeholder="Enter Secret Key"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.STRIPE_LIVE_SECRET &&
                              touched.STRIPE_LIVE_SECRET &&
                              errors.STRIPE_LIVE_SECRET
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                )}
              </CardContent>
              {!permissionAccess ? (
                <CardContent
                  sx={{
                    backgroundColor: 'rgba(0, 0, 0, 0.06)',
                    p: 2,
                    columnGap: '16px',
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    // fullWidth
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                      setModeValue(data?.STRIPE_MODE);
                    }}
                  >
                    Clear
                  </Button>
                </CardContent>
              ) : (
                ''
              )}
            </Card>
          </form>
        )}
      </Formik>
    </Box>
  );
}
